module.exports = __webpack_public_path__ + "ae3e6b06459735f9aebe12d21daa2a2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/gamecenter/eg/phoenixwar.jpg
// module id = 645
// module chunks = 30